export default __webpack_public_path__ + "static/media/login.aec7e272.svg";